import { render, staticRenderFns } from "./HostessTab.vue?vue&type=template&id=8ca7fd58&scoped=true"
import script from "./HostessTab.vue?vue&type=script&lang=js"
export * from "./HostessTab.vue?vue&type=script&lang=js"
import style0 from "./HostessTab.vue?vue&type=style&index=0&id=8ca7fd58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca7fd58",
  null
  
)

export default component.exports